/*
	These values must correspond to the CSS
	media queries in _client/style/_mixins.scss
*/
enum media {
	MOBILE = '(max-device-width: 767px), (max-device-height: 719px) and (orientation: landscape)',
	DESKTOP = '(min-device-width: 768px) and (min-device-height: 720px)',
	DESKTOP1280 = '(min-device-width: 768px) and (min-device-height: 720px) and (min-width: 1280px)',
	DESKTOP1440 = '(min-device-width: 768px) and (min-device-height: 720px) and (min-width: 1440px)'
}

export default media;
